export const getMediaUrl = (path, version = 1) => `${process.env.NEXT_PUBLIC_API_ENTRYPOINT}${path}?v=${version}`
